import { PNCTypes, Dictionary, IntegerDictionary, LanguageCode, LANGUAGE_NAMES } from "./TypesAndEnums"
//import * as DBTypes from "./database"
import { PNCDatabase, AvgCharacter } from "./database";
declare var __JS_SCRIPTS_PATH: string;


//TODO: Remove all this crap and rename it to something like "DatabaseHelpers"

export class DatabaseAPI {

	// @ts-ignore: Object is possibly 'null'.
	database:PNCTypes.Database;

	/**
	 * Description
	 * @param {string} CACHE_KEY
	 */
	constructor(
		CACHE_KEY="pncApiResponseCache",
		SERVER_URL="https://russellpuff.net"
	) {
		//this.SERVER_URL = SERVER_URL;
		//getDatabaseVersion loads the database.
	}

	async getAllNavData():Promise<PNCTypes.Chapter[]> {

		let flat = Object.values(this.database.story.main).concat(this.database.story.event).concat(this.database.story.side)
		return flat as PNCTypes.Chapter[];
	}

	hasEpisode(permalink:string):boolean {
		return this.database.story.__hashtable.hasOwnProperty(permalink);
	}

	/* Get an episode + the parent chapter name */
	async getEpisode(permalink:string):Promise<PNCTypes.Episode> {

		const ep = this.database.story.__hashtable[permalink] as PNCTypes.Episode;
		if (ep == null) {
			throw new Error("this episode is not in the database");
		}
		return ep;
	}

	getPrevEpisode(permalink:string):string {
		let idx = this.database.story.__indexes.indexOf(permalink);
		if (idx > 0) { //Not >=0 because we want to stop at 0
			return this.database.story.__indexes[idx-1]
		}
		return "";
	}

	getNextEpisode(permalink:string):string {
		let idx = this.database.story.__indexes.indexOf(permalink);
		if (idx >= 0) {
			return this.database.story.__indexes[idx+1]
		}
		return "";
	}

	/** 
	 * Pass in an array of speaker ids, get out an array of human-readable names :)
	 * @param {Set<number>|number[]} characters The set of characters you are requesting.
	 * @returns {Promise<String[]>}
	 */ 
	async getSpeakers(speakers:Set<number>|number[], language:LanguageCode) {
		return [...speakers].filter(key => key in this.database.speakers)
		.map(key => this.database.speakers[key])
	}
	
	async getSpeakersByLanguage(speakers:Set<number>|number[], langauge:LanguageCode):Promise<Map<number,string>> {
		let LANGUAGE_INDEX = Object.values(LANGUAGE_NAMES).indexOf(langauge);
		if (LANGUAGE_INDEX < 0) //If invalid language specified somehow, default to 0 (english)
			LANGUAGE_INDEX = 0;

		//let ret = [...speakers].filter(key => key in this.database.speakers)
		//.map(key => this.database.speakers[key][LANGUAGE_INDEX])
		let map = new Map<number,string>();
		let tmp = [...speakers]; //Convert set to array
		for (let i = 0; i < tmp.length; i++) {
			const key = tmp[i];
			if (key in this.database.speakers) {
				//TODO This StringList type is confusing and should probably be replaced with regular arrays during the deserialization step
				map.set(key, this.database.speakers[key].values?.[LANGUAGE_INDEX] || "Speaker ID "+key.toString()+" does not have an entry for language "+langauge+" (Lang ID "+LANGUAGE_INDEX.toString()+")")
			}
		}
		return map;
	}

	/**
	 * Similar to getSpeakers except it returns an array of objects with character sprite data.
	 * @param {Set<string>|String[]} characters The set of characters you are requesting. To request ALL, use getCharacters(["ALL"])
	 * @returns {Promise<Map<string, AvgCharacter>>}
	 */
	async getCharacterPortraits(characters:Set<string>|String[]): Promise<Dictionary<AvgCharacter>> {

		return this.database.characters;
	}

	/**
	 * 
	 * @returns {Promise<number>} database version
	 */
	async getDatabaseVersion() {

		// You cannot await inside a constructor... 
		// But this might lead to a race condition where the other functions are called before database.json is ready
		// That's why we call it here

		// Add ? to the end (discarded by apache/nginx)
		// which will force stupid mobile browsers to not cache the result
		// database.json doesn't change often, so maybe better to refresh every week instead. But it compresses down to 64kb so does it really matter?
		const today = new Date();
		return fetch(__JS_SCRIPTS_PATH+'database.protobuf?nocache='+String(today.getMonth()+"."+today.getDate()))
		.then(resp => resp.bytes())
		.then(binary => {
			this.database = PNCDatabase.decode(binary) as PNCTypes.Database;
			console.log(this.database);
			//debugger;

			//Build the hash table here
			this.database.story['__hashtable'] = {};
			this.database.story['__indexes'] = []

			let flat = Object.values(this.database.story.main).concat(this.database.story.event).concat(this.database.story.side)
			for (let i = 0; i < flat.length; i++) {
				let chapter = flat[i];
				for (let j = 0; j < chapter.episodes.length; j++) {
					let episode = chapter.episodes[j] as PNCTypes.Episode;
					episode.chapterName = chapter.name;
					let permalink = episode.permalink;
					if (permalink == null) {
						permalink = episode.parts?.[0]?.script;
						episode.permalink = permalink;
					}

					this.database.story['__hashtable'][permalink] = episode;
					this.database.story['__indexes'].push(permalink);
				}
			}

			//debugger;
			return 0 //Database OK!!
		})
	}
}
